import { render, staticRenderFns } from "./DetailSettings.vue?vue&type=template&id=1b3217d2&scoped=true&"
import script from "./DetailSettings.vue?vue&type=script&lang=js&"
export * from "./DetailSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3217d2",
  null
  
)

export default component.exports